import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrPptxReport = createSelector(
  [selectQbrState],
  ({ pptxReportState }) => pptxReportState.pptxReport
)
